var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69 78H63V99H69V78Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 93V47.985C21 33.1075 33.105 20.995 47.9825 20.985L84 20.965V26.965L47.9875 26.985C36.415 26.9925 27.0025 36.4125 27.0025 47.985V93H21Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2 102.745L40.8 96.745L32.4 102.745L22.255 95.5C20.9075 94.5375 20.595 92.6625 21.5575 91.315C22.52 89.9675 24.3925 89.655 25.7425 90.6175L32.4 95.3725L40.8 89.3725L49.2 95.3725L57.6 89.3725L67.7425 96.6175C69.09 97.58 69.4025 99.455 68.44 100.802C67.4775 102.15 65.6025 102.462 64.255 101.5L57.6 96.745L49.2 102.745Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84 84C78.125 84 72.705 80.5375 68.735 74.2475C65.0375 68.3875 63 60.6575 63 52.48C63 44.3025 65.0375 36.5725 68.735 30.7125C72.705 24.425 78.125 20.96 84 20.96C89.875 20.96 95.295 24.4225 99.265 30.7125C102.963 36.5725 105 44.3025 105 52.48C105 60.6575 102.963 68.3875 99.265 74.2475C95.295 80.535 89.875 84 84 84ZM84 26.9625C75.87 26.9625 69 38.6475 69 52.48C69 66.3125 75.87 77.9975 84 77.9975C92.13 77.9975 99 66.3125 99 52.48C99 38.6475 92.13 26.9625 84 26.9625Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84 69C78.0925 69 75 60.7 75 52.5C75 44.3 78.0925 36 84 36C89.9075 36 93 44.3 93 52.5C93 60.7 89.9075 69 84 69ZM84 42.0175C83.115 42.44 81 46.065 81 52.5C81 58.935 83.115 62.56 84 62.9825C84.885 62.56 87 58.935 87 52.5C87 46.065 84.885 42.44 84 42.0175Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWc);
export default __webpack_public_path__ + "static/media/WC.fee663cb.svg";
export { ForwardRef as ReactComponent };